import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography, Box } from '@material-ui/core';
import useStyles from 'isomorphic-style-loader/useStyles';
import ProgressWithPercentageCss from './ProgressWithPercentage.scss';

function ProgressWithPercentage({ seconds = 30, initialWord = 'Generating' }) {
  const [progress, setProgress] = useState(0);
  const [word, setWord] = useState(initialWord);
  const [spinnerVariant, setSpinnerVariant] = useState('determinate');
  useStyles(ProgressWithPercentageCss);

  useEffect(
    () => {
      const interval = 1000;
      const phaseOneEnd = seconds / 2;
      const totalIntervalsInPhaseOne = phaseOneEnd;
      const delta = 100 / totalIntervalsInPhaseOne;
      let elapsedSeconds = 0;

      const timerId = setInterval(() => {
        elapsedSeconds += 1;

        if (elapsedSeconds <= phaseOneEnd) {
          setProgress(prevProgress => Math.min(prevProgress + delta, 100));
        } else {
          setWord('Still waiting');
          setSpinnerVariant('indeterminate');
          clearInterval(timerId);
        }
      }, interval);

      return () => clearInterval(timerId);
    },
    [seconds],
  );

  return (
    <Box display="flex" alignItems="center" className="progress-with-percentage">
      <Typography style={{ marginRight: '8px', marginTop: '4px' }}>{word}</Typography>

      <Box display="flex" alignItems="center" position="relative">
        <CircularProgress
          className="progress-with-percentage__outer-circle"
          variant="determinate"
          value={100}
          size={32}
          thickness={8}
        />
        <CircularProgress
          variant={spinnerVariant}
          value={spinnerVariant === 'determinate' ? progress : undefined}
          size={32}
          thickness={8}
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      </Box>
    </Box>
  );
}

ProgressWithPercentage.propTypes = {
  seconds: PropTypes.number,
  initialWord: PropTypes.string,
};

ProgressWithPercentage.defaultProps = {
  seconds: 30,
  initialWord: 'Generating',
};

export default ProgressWithPercentage;
